/**
 * POST /auth/logout - Logout current session
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import { getCookie, deleteCookie } from 'hono/cookie'
import type { AuthService } from '../auth.service.js'
import { getRequestInfo } from './helpers.js'

export const logoutAction: ActionDefinition = {
  key: 'logout',
  label: { en: 'Logout', es: 'Cerrar sesión' },
  icon: 'mdi:logout',
  scope: 'module',
  group: { en: 'Sessions', es: 'Sesiones' },
  method: 'POST',
  successStatus: 204,
  middleware: (ctx) => [
    ctx.core.middleware['auth'] as MiddlewareHandler,
    (ctx.services.get('authRateLimits') as { logout: MiddlewareHandler }).logout
  ],
  input: {
    refreshToken: { input: 'text', label: { en: 'Refresh Token (optional)', es: 'Token de refresco (opcional)' } }
  },
  handler: async (ctx, input, c) => {
    const body = input as { refreshToken?: string; _authUserId?: string }
    const cookieToken = c ? getCookie(c, 'refreshToken') : undefined
    const refreshToken = body.refreshToken || cookieToken

    const authService = ctx.services.get<AuthService>('auth')
    if (refreshToken) {
      await authService.logout(refreshToken, body._authUserId, getRequestInfo(c))
    }

    if (c) deleteCookie(c, 'refreshToken', { path: '/api/v1' })
    return undefined
  }
}
